(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ngr-plate-preview')) {
    customElements.define('ngr-plate-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('.ngr-plate-color');
          if (!button || !this.contains(button)) return;
          this.selectColor(button);
        });
        const first = this.querySelector('.ngr-plate-color');
        if (first) this.selectColor(first);
      }
      selectColor(button) {
        this.querySelectorAll('.ngr-plate-color').forEach(swatch => {
          swatch.setAttribute('aria-pressed', String(swatch === button));
        });
        this.querySelector('.ngr-plate-color-name').textContent = button.dataset.color;
        if (!button.dataset.image) return;
        const image = this.closest('.card-product').querySelector('.card-product__media img');
        if (!image) return;
        const picture = image.closest('picture');
        if (picture) picture.querySelectorAll('source').forEach(source => source.removeAttribute('srcset'));
        image.removeAttribute('srcset');
        image.src = button.dataset.image;
        image.alt = this.closest('.card-product').querySelector('.card__heading').textContent.trim() + ' — ' + button.dataset.color;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ngr-closed"] && !Shopify.designMode) return;
  try {
    
function setupClosedVideos(root=document){
  root.querySelectorAll('.ngr-closed__hero').forEach(hero=>{
    const video=hero.querySelector('video');
    const button=hero.querySelector('button');
    if(!video||!button||button.dataset.ready)return;
    button.dataset.ready='true';
    const update=()=>{button.setAttribute('aria-label',video.paused?button.dataset.play:button.dataset.pause);button.querySelector('span').textContent=video.paused?'▶':'Ⅱ';};
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){video.autoplay=false;video.pause();}
    button.addEventListener('click',()=>{if(video.paused){video.play().catch(()=>{});}else{video.pause();}});
    video.addEventListener('play',update);
    video.addEventListener('pause',update);
    update();
  });
}
setupClosedVideos();
document.addEventListener('shopify:section:load',event=>setupClosedVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ngr-jersey-drop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ngr-countdown')) customElements.define('ngr-countdown', class extends HTMLElement {
    connectedCallback() { this.update(); this.clock = setInterval(() => this.update(), 1000); }
    disconnectedCallback() { clearInterval(this.clock); }
    update() { const end = Date.parse(this.dataset.end); if (!Number.isFinite(end)) return; const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000)); if (remaining === 0) { this.textContent = this.dataset.closed; clearInterval(this.clock); return; } const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 }; Object.entries(values).forEach(([key,value]) => { const el = this.querySelector('[data-' + key + ']'); if(el) el.textContent = String(value).padStart(2,'0'); }); }
  });
  if (!customElements.get('ngr-product-views')) customElements.define('ngr-product-views', class extends HTMLElement {
    connectedCallback() { if(this.ready) return; this.ready = true; this.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => { this.dataset.active = button.dataset.view; this.querySelectorAll('[data-view]').forEach(item => item.setAttribute('aria-pressed',String(item === button))); })); }
  });
  function ngrInitHero(root) {
    root.querySelectorAll('.ngr-hero').forEach(hero => {
      const video = hero.querySelector('.ngr-hero__video');
      if (!video) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { video.autoplay = false; video.pause(); }
    });
  }
  ngrInitHero(document);
  document.addEventListener('shopify:section:load',event => ngrInitHero(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ngr-password-access"]) return;
  try {
    
if (!customElements.get('ngr-sms-subscribe')) {
  customElements.define('ngr-sms-subscribe', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.phone = this.form.elements.phone_number;
      this.country = this.form.elements.country;
      this.button = this.form.querySelector('button');
      this.status = this.form.querySelector('[role="status"]');
      this.originalLabel = this.button.textContent;
      this.button.disabled = false;
      this.form.addEventListener('submit', event => this.subscribe(event));
      this.phone.addEventListener('input', () => {
        this.phone.setCustomValidity('');
        this.phone.removeAttribute('aria-invalid');
      });
      this.country.addEventListener('change', () => {
        this.phone.setCustomValidity('');
        this.phone.removeAttribute('aria-invalid');
        this.phone.focus();
      });
    }
    normalizePhone(value, country) {
      const clean = value.trim();
      if (!/^\+?[\d\s().-]+$/.test(clean)) return null;
      let digits = clean.replace(/\D/g, '');
      if (clean.startsWith('+')) return /^\+[1-9]\d{7,14}$/.test('+' + digits) ? '+' + digits : null;
      if (country === 'international') return null;
      const code = country === 'CA' ? '1' : country;
      if (code === '1') {
        if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
        return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits) ? '+1' + digits : null;
      }
      if (digits.startsWith(code) && digits.length > 10) digits = digits.slice(code.length);
      digits = digits.replace(/^0/, '');
      const full = '+' + code + digits;
      return /^\+[1-9]\d{7,14}$/.test(full) ? full : null;
    }
    showStatus(message, error = false) {
      this.status.textContent = message;
      this.status.dataset.error = String(error);
      this.status.hidden = false;
      this.status.focus();
    }
    async subscribe(event) {
      event.preventDefault();
      if (this.busy || this.completed) return;
      const number = this.normalizePhone(this.phone.value, this.country.value);
      if (!number) {
        this.phone.setCustomValidity(this.dataset.invalid);
        this.phone.setAttribute('aria-invalid', 'true');
        this.phone.reportValidity();
        return;
      }
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.pending;
      this.form.setAttribute('aria-busy', 'true');
      this.status.hidden = true;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.dataset.companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-07-15' },
          credentials: 'omit',
          signal: controller.signal,
          body: JSON.stringify({data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Next Gen Racing password page SMS signup',
              profile: {data: {type: 'profile', attributes: {
                phone_number: number,
                subscriptions: {sms: {marketing: {consent: 'SUBSCRIBED'}}}
              }}}
            },
            relationships: {list: {data: {type: 'list', id: this.dataset.listId}}}
          }})
        });
        if (response.status !== 202) {
          this.showStatus(response.status === 429 ? this.dataset.rateLimit : this.dataset.error, true);
          return;
        }
        this.completed = true;
        this.form.querySelector('.ngr-sms__phone-row').hidden = true;
        this.button.hidden = true;
        this.button.style.display = 'none';
        this.showStatus(this.dataset.success);
      } catch (error) {
        this.showStatus(this.dataset.error, true);
      } finally {
        clearTimeout(timeout);
        this.busy = false;
        this.form.removeAttribute('aria-busy');
        this.button.disabled = this.completed === true;
        this.button.textContent = this.originalLabel;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ngr-sliding-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ngr-sliding-countdown')) {
    customElements.define('ngr-sliding-countdown', class extends HTMLElement {
      connectedCallback() {
        this.target = /(?:Z|[+-]\d{2}:\d{2})$/i.test(this.dataset.deadline) ? Date.parse(this.dataset.deadline) : NaN;
        this.times = this.querySelectorAll('[data-time]');
        this.button = this.querySelector('button');
        this.onPause = () => {
          const paused = this.toggleAttribute('data-paused');
          this.button.setAttribute('aria-pressed', String(paused));
          this.button.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
        };
        this.button.addEventListener('click', this.onPause);
        if (!Number.isFinite(this.target)) return;
        this.renderTime();
        if (this.target > Date.now()) this.interval = setInterval(() => this.renderTime(), 1000);
      }
      renderTime() {
        const total = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
        const values = [Math.floor(total / 86400), Math.floor(total % 86400 / 3600), Math.floor(total % 3600 / 60), total % 60];
        const value = values.map((n, i) => String(n).padStart(2, '0') + ['D', 'H', 'M', 'S'][i]).join(' : ');
        this.times.forEach(el => { el.textContent = total ? value : this.dataset.expired; });
        if (!total) {
          this.querySelectorAll('[data-caption]').forEach(el => { el.hidden = true; });
          clearInterval(this.interval);
        }
      }
      disconnectedCallback() {
        clearInterval(this.interval);
        this.button?.removeEventListener('click', this.onPause);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ngr-support"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    root.querySelectorAll('.ngr-support').forEach((section) => {
      const topic = section.querySelector('[data-support-topic]');
      const hint = section.querySelector('[data-support-hint]');
      if (topic && hint && !topic.dataset.initialized) {
        const updateHint = () => { hint.textContent = topic.selectedOptions[0].dataset.hint; };
        topic.addEventListener('change', updateHint);
        topic.dataset.initialized = 'true';
        updateHint();
      }
      const feedback = section.querySelector('[data-support-feedback]');
      if (feedback) feedback.focus();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
